// Libraries
import { Component, ReactNode } from 'react';
// eslint-disable-next-line
import { Notifier } from '@airbrake/browser';

// Components
import Header from './components/organisms/Header/Header';
import ErrorUndefined from './components/templates/StateScreen/ErrorUndefined';

// Constants
import { ERROR_GENERIC } from './utils/constants/constants';

// Styles
import styles from './App.module.css';

/**
 * @class ErrorBoundary
 * Proivdes a wrapper for airbrake to test within
 *
 * @extends Component
 *
 * @example
 * return (
 *   <ErrorBoundary></ErrorBoundary>
 * )
 */
class ErrorBoundary extends Component<
    { children: ReactNode },
    { error: null }
> {
    airbrake;
    constructor(props: any) {
        super(props);
        this.state = { error: null };
        this.airbrake = new Notifier({
            projectId: 474150,
            projectKey: 'd5837920b635382968a337ce548941c6',
        });
    }

    componentDidCatch(error: any, info: any) {
        // Display fallback UI
        this.setState({ error });
        // Send error to Airbrake
        this.airbrake.notify({
            error: error,
            params: { info: info },
        });
    }

    render() {
        if (this.state.error) {
            // You can render any custom fallback UI
            return (
                <div className={styles.container}>
                    {/* <Header /> */}
                    <ErrorUndefined error={ERROR_GENERIC} />
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
